module.exports = __webpack_public_path__ + "media/images/favicons/48x48-924e149751ca6fe2dbc8aa2eb45e0a31.png";